<template>
  <section class="career-growth-section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-8">
          <div class="career-content">
            <h2 class="career-title">{{ careerData.title }}</h2>
            <p class="career-description">{{ careerData.description }}</p>
            <button class="career-btn" @click="handleButtonClick">
              {{ careerData.buttonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ServiceItsCareerGrowthComp",
  props: {
    careerData: {
      type: Object,
      required: true,
      default: () => ({
        title: "Grow your career with us",
        description: "Unlock endless opportunities for innovation, development, and professional growth in a dynamic, forward-thinking environment.",
        buttonText: "Find your next job",
        buttonLink: "/careers"
      })
    },
    backgroundImage: {
      type: String,
      default: "~@/assets/resource/portfolio-bg.jpg"
    }
  },
  methods: {
    handleButtonClick() {
      if (this.careerData.buttonLink) {
        this.$router.push(this.careerData.buttonLink);
      }
    }
  }
};
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* Career Growth Section */
.career-growth-section {
  padding: 100px 0;
  background: #000 url('~@/assets/resource/portfolio-bg.jpg') no-repeat;
  background-position: left 0%;
  background-attachment: fixed;
  position: relative;
  overflow: hidden;
}

.career-content {
  padding: 40px 0;
  position: relative;
  z-index: 10;
}

.career-title {
  font-size: 48px;
  font-weight: 700;
  color: #ff4500;
  margin-bottom: 20px;
  line-height: 1.2;
  font-family: 'Archivo', sans-serif;
}

.career-description {
  font-size: 18px;
  color: #b0b0b0;
  line-height: 1.6;
  margin-bottom: 30px;
  max-width: 500px;
}

.career-btn {
  background: #ff4500;
  color: #fff;
  border: none;
  padding: 15px 30px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: none;
}

.career-btn:hover {
  background: #e03d00;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(255, 69, 0, 0.3);
}

/* Responsive Design */
@media (max-width: 991px) {
  .career-growth-section {
    padding: 80px 0;
  }
  
  .career-title {
    font-size: 36px;
  }
  
  .career-description {
    font-size: 16px;
  }
}

@media (max-width: 767px) {
  .career-title {
    font-size: 28px;
  }
  
  .career-description {
    font-size: 14px;
  }
  
  .career-btn {
    padding: 12px 24px;
    font-size: 14px;
  }
}
</style>
